import React, { FC, ReactNode } from 'react';

import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './ToggleDecorator.module.scss';

export type ToggleDecoratorProps = {
  children: ReactNode;
  size?: 'regular' | 'large';
};

const ToggleDecorator: FC<ToggleDecoratorProps> = ({
  children,
  size = 'regular',
}) => (
  <span className={getClassNames(styles, 'root', classNames({ large: size === 'large' }))}>
    {children}
    <span className={getClassNames(styles, 'thumb', classNames({ large: size === 'large' }))} />
  </span>
);

export default ToggleDecorator;
